export default "__VITE_ASSET__B476EFXk__"